import { isEmptyValue } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'acl-select',
    components: {
    },
})

export default class AclSelect extends Vue {

    @Prop()
    private cohort: any;

    @Prop()
    private aclList: any;

    @Prop()
    private index: any;

    @Prop()
    private isSubmitted: any;

    @Prop()
    private selection: any;

    @Prop({default: ''})
    private selectionChild: any;

    private get isDropDownValidation() {
        if (this.isSubmitted && isEmptyValue(this.selection)) {
            return false;
        }
    }

    private onSelectListItem(acl: any) {
        this.$emit('onSelectListItem', this.cohort.type, acl, this.index);
    }
}
